import people from "../../../../../Images/grad.svg";
import { useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import {
  useGetEmployeeByContainerIdQuery,
  useGetHrDepartmentsQuery,
} from "../../../../../../api/hrApi";
import DashboardStyle from "../../../../../../dashboard/Styles/Dashboard.module.css";
import {
  FormSelect,
  FormTemplate,
} from "../../../../../Components/Forms/InputTemplate";
import member from "../../../../../Images/member.svg";
import { GetDepartment } from "../../../../../../../utils/redux/Employee/EmployeeSlice";
import { useDispatch, useSelector } from "react-redux";

const MemberModal = ({
  isOpen,
  setIsOpen,
  onValidate = () => {},
  openNext = (rev) => rev,
  onBack = () => {},
  cachedData = null,
}) => {
  const [selectedMembers, setSelectedMembers] = useState([]);

  const { data: department, isLoading } = useGetHrDepartmentsQuery({
    PageSize: 1000,
    PageNumber: 1,
  });

  const formMethods = useForm({
    mode: "all",
    defaultValues: cachedData || {},
  });
  const {
    handleSubmit,
    formState: { isValid },
    watch,
  } = formMethods;
  const id = watch("departmentId");
  const otherDepartmentId = watch("otherDepartmentId");
  // const { data } = useGetEmployeeByContainerIdQuery(id);

  const dispatch = useDispatch();
  // const datas = useSelector(
  //     (state) => state?.employee?.get_department?.result
  //   );
  const [data, setData] = useState({})
  useEffect(() => {
  dispatch(
          GetDepartment({
            pageNumber: 1,
           pageSize: 10000,
            DepartmentId: id, setResult: setData, hideError: true
          }, )
        );
  },[id])
  
  const [otherEmployee, setOtherEmployee] = useState({})
  useEffect(() => {
  dispatch(
          GetDepartment({
            pageNumber: 1,
            pageSize: 10000,
            DepartmentId: otherDepartmentId, setResult: setOtherEmployee,
            hideError: true
          })
        );
  },[otherDepartmentId])
  // const { data: otherEmployee } = useGetEmployeeByContainerIdQuery(otherDepartmentId);
  const handleMemberSelection = (member, isChecked) => {
    if (isChecked) {
      setSelectedMembers((prev) => [...prev, member]);
    } else {
      setSelectedMembers((prev) => prev.filter((m) => m.id !== member.id));
    }
  };

  const removeMember = (memberId) => {
    setSelectedMembers((prev) => prev.filter((m) => m.id !== memberId));
  };

  const isMemberSelected = (memberId) => {
    return selectedMembers.some((m) => m.id === memberId);
  };
  const submit = (data) => {
    const memberData = {
      ...data,
      selectedMembers: selectedMembers,
      memberIds: selectedMembers.map((m) => m.id),
    };

    console.log("Selected members:", memberData);

    if (selectedMembers.length === 0) {
      alert("Please select at least one member");
      return;
    }

    onValidate();
    openNext(memberData);
  };

  useEffect(() => {
    if (id && id !== "0" && id !== 0) {
      setSelectedMembers([]);
    }
  }, [id]);

  // Restore selected members from cached data
  useEffect(() => {
    if (cachedData?.selectedMembers) {
      setSelectedMembers(cachedData.selectedMembers);
    }
  }, [cachedData]);
const [openOtherDepartment, setOpenOtherDepartment] = useState(false);
  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <div className="flex justify-between items-center mt-5 px-5">
                <div className="flex gap-2">
                  <button 
                    type="button" 
                    onClick={onBack}
                    className="bg-gray-100 text-gray-600 px-4 py-2 rounded-sm hover:bg-gray-200"
                  >
                    Back
                  </button>
                  <button type="button" onClick={() => setIsOpen(!isOpen)}>
                    Cancel
                  </button>
                </div>
                <div>
                  <button type="submit">Next</button>
                </div>
              </div>
              <div>
                <FormSelect
                  title={"Department"}
                  camelCase={"departmentId"}
                  placeholder={"select"}
                  array={department?.responseObject?.pageItems?.map((opt) => (
                    <option key={opt.value} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                  defaultValue={0}
                />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 mb-2 block">
                  Selected Members ({selectedMembers.length})
                </label>
                <div className="selectedMembers bg-[#F8FBF8] border border-[#D9E9DA] rounded-sm p-3 min-h-[80px]">
                  {selectedMembers.length === 0 ? (
                    <p className="text-gray-500 text-sm">No members selected</p>
                  ) : (
                    <div className="flex flex-wrap gap-2">
                      {selectedMembers.map((selectedMember) => (
                        <div
                          key={selectedMember.id}
                          className="bg-white border border-gray-300 rounded-full px-3 py-1 flex items-center space-x-2 text-sm"
                        >
                          <span className="text-gray-700">
                            {selectedMember.firstName} {selectedMember.surname}
                          </span>
                          <button
                            type="button"
                            onClick={() => removeMember(selectedMember.id)}
                            className="text-gray-400 hover:text-gray-600 focus:outline-none"
                          >
                            <FiX size={14} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="px-5">
                <label className="text-sm font-medium text-gray-700 mb-2 block">
                  Available Members
                </label>
                <div className="space-y-3 max-h-96 overflow-y-auto border border-gray-200 rounded-sm p-3">
                  {data?.result?.map((item) => (
                    <div
                      key={item.id}
                      className="flex justify-between items-center py-2 border-b border-gray-100 last:border-b-0"
                    >
                      <div className="flex items-center space-x-3">
                        <div>
                          <img
                            src={member}
                            alt="member icon"
                            className="w-5 h-5"
                          />
                        </div>
                        <div>
                          <p className="text-gray-800">
                            {item.firstName} {item.surname}
                          </p>
                        </div>
                      </div>
                      <div>
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={isMemberSelected(item.id)}
                            onChange={(e) =>
                              handleMemberSelection(item, e.target.checked)
                            }
                            className="sr-only"
                          />
                          <div
                            className={`w-4 h-4 rounded border-2 flex items-center justify-center ${
                              isMemberSelected(item.id)
                                ? "bg-[#18BB0C] border-[#18BB0C]"
                                : "bg-white border-gray-300 hover:border-gray-400"
                            }`}
                          >
                            {isMemberSelected(item.id) && (
                              <svg
                                className="w-3 h-3 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                          </div>
                        </label>
                      </div>
                    </div>
                  ))}
                  {data?.result?.length === 0 && (
                    <p className="text-gray-500 text-center py-4">
                      No members found in selected department
                    </p>
                  )}
                </div>
              </div>
                            <div className="flex justify-between my-4">
                <div className="w-2" />
                <button onClick={() => setOpenOtherDepartment(true)}
                  type="button"
                  className="bg-[#18BB0C1A] text-[#18BB0C] px-5 py-2 rounded-sm flex items-center space-x-2"
                >
                  <img src={people} alt="people grag icon" />{" "}
                  <span>Add  Member from Other Departments</span>
                </button>
                </div>
                {openOtherDepartment && <>
                                <FormSelect
                  title={"Other Department"}
                  camelCase={"otherDepartmentId"}
                  placeholder={"select"}
                  array={department?.responseObject?.pageItems?.filter(dat => dat?.id !== id)?.map((opt) => (
                    <option key={opt.value} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                  defaultValue={0}
                /> 
                             <div className="px-5">
                <label className="text-sm font-medium text-gray-700 mb-2 block">
                Other Department  Available Members
                </label>
                <div className="space-y-3 max-h-96 overflow-y-auto border border-gray-200 rounded-sm p-3">
                  {otherEmployee?.result?.map((item) => (
                    <div
                      key={item.id}
                      className="flex justify-between items-center py-2 border-b border-gray-100 last:border-b-0"
                    >
                      <div className="flex items-center space-x-3">
                        <div>
                          <img
                            src={member}
                            alt="member icon"
                            className="w-5 h-5"
                          />
                        </div>
                        <div>
                          <p className="text-gray-800">
                            {item.firstName} {item.surname}
                          </p>
                        </div>
                      </div>
                      <div>
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={isMemberSelected(item.id)}
                            onChange={(e) =>
                              handleMemberSelection(item, e.target.checked)
                            }
                            className="sr-only"
                          />
                          <div
                            className={`w-4 h-4 rounded border-2 flex items-center justify-center ${
                              isMemberSelected(item.id)
                                ? "bg-[#18BB0C] border-[#18BB0C]"
                                : "bg-white border-gray-300 hover:border-gray-400"
                            }`}
                          >
                            {isMemberSelected(item.id) && (
                              <svg
                                className="w-3 h-3 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                          </div>
                        </label>
                      </div>
                    </div>
                  ))}
                  {data?.result?.length === 0 && (
                    <p className="text-gray-500 text-center py-4">
                      No members found in selected department
                    </p>
                  )}
                </div>
              </div>
                </>
                } 

            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default MemberModal;
